import * as types from '../constants/ActionTypes';
import client from '../lib/frost-web-client';
import logout from '../lib/logout';


export function requestLotList () {
	return { type: types.REQUEST_LOT_LIST };
}

export function receiveLotList (response) {
	return { type: types.RECEIVE_LOT_LIST, response };
}

export function receiveLotListError (error) {
	return { type: types.RECEIVE_LOT_LIST_ERROR, error };
}

export function fetchLotList (params) {
	return dispatch => {

		dispatch(requestLotList());

		return client.get('/api/lots', params)
			.then(response => dispatch(receiveLotList(response.body)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveLotListError(error.response));
				}
			});
	};
}

export function submitEditLot () {
	return { type: types.SUBMIT_EDIT_LOT };
}

export function resolveEditLot (response, id, data) {
	return { type: types.RESOLVE_EDIT_LOT, id, data };
}

export function receiveEditLotError (error) {
	return { type: types.RECEIVE_EDIT_LOT_ERROR, error };
}

export function editLot (id, data) {
	return dispatch => {

		dispatch(submitEditLot());

		return client.put(`/api/lots/${id}`, data)
			.then(response => dispatch(resolveEditLot(response, id, data)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveEditLotError(error.response));
				}
			});

	};
}

export function requestLotCounts () {
	return { type: types.REQUEST_LOT_COUNTS };
}

export function receiveLotCounts (response) {
	return { type: types.RECEIVE_LOT_COUNTS, response };
}

export function receiveLotCountsError (error) {
	return { type: types.RECEIVE_LOT_COUNTS_ERROR, error };
}

export function fetchLotCounts (params) {
	return dispatch => {

		dispatch(requestLotCounts());

		return client.head('/api/lots', params)
			.then(response => dispatch(receiveLotCounts(response)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveLotCountsError(error.response));
				}
			});
	};
}



// WEBPACK FOOTER //
// ./src/assets/js/actions/lots.js